// extracted by mini-css-extract-plugin
export default {"brandPromo":"wH-z","carousel":"xH-z"};